import React, { useEffect, useMemo, useRef, useState } from 'react';
import { CenterModal } from 'react-spring-modal';
import { useRecoilState, useRecoilValue } from 'recoil';
import {
	InnerModalOpen,
	userConnected,
	WalletConnectModalOpen,
} from '../recoil-states/user-state/user-state';
import { isMobile } from 'react-device-detect';
import closebtn from '../assets/icons/closebtn.svg';
import walletconnet from '../assets/icons/walletconnet.svg';
import metamask from '../assets/icons/metamask.svg';
import copyBtn from '../assets/icons/copy_btn.png';
import '../css/modal.css';
import { OAuthData, WalletState } from '../recoil-states/user-state/user-OAuth';
import {
	decryptedData,
	_getOnChainCollectionItems,
} from '../function/functions';

const WalletConnectModal = ({
	_walletConnect,
	connet_walletConnect,
	address,
	textData,
	isAuthenticated,
	isWeb3Enabled,
	logout,
	connector,
	_alreadyLinkedConnetWalletConnect,
}) => {
	const [walletConnectmodal, setWalletConnectModal] = useRecoilState(
		WalletConnectModalOpen
	);
	const [walletState, setWalletState] = useRecoilState(WalletState);
	const walletStateValue = useRecoilValue(WalletState);
	const [isOpen, setIsOpen] = useRecoilState(InnerModalOpen);
	const [userData, setUserhData] = useRecoilState(OAuthData);
	const [isHover, setIsHover] = useState(false);
	const OAuthDataValue = useRecoilValue(OAuthData);
	let userAddress =
		userData && userData?.link_State ? userData.wallet_address : '' ?? '';
	let WalletConnector;
	const AddressRef = useRef(null);
	const _copyToClipBoard = async text => {
		if (!text) return;
		try {
			await navigator.clipboard.writeText(text);
			alert(textData.mypage2.copyAdress);
		} catch (error) {
			alert('주소 복사에 실패했습니다.');
		}
	};

	const _WalletConnector = () => {
		if (!isAuthenticated) {
			WalletConnector = [
				{
					id: 1,
					name: 'Metamask',
					img: metamask,
					connector: connector ?? '',
					provider: 'metamask',
				},
				{
					id: 2,
					name: 'Wallet Connect',
					img: walletconnet,
					connector: connector ?? '',
					provider: 'walletconnect',
				},
			];
		} else if (!isMobile && isAuthenticated) {
			WalletConnector = [
				{
					id: 1,
					name: 'Metamask',
					img: metamask,
					connector: connector ?? '',
					provider: 'metamask',
				},
			];
		} else if (isMobile && isAuthenticated) {
			WalletConnector = [
				{
					id: 2,
					name: 'Wallet Connect',
					img: walletconnet,
					connector: connector ?? '',
					provider: 'walletconnect',
				},
			];
		}
		return WalletConnector.map((item, index) => {
			return (
				<div
					key={index}
					className='WalletConnectModal_Connector'
					// onClick={() => {
					// setWalletConnectModal(false);
					// }}
				>
					<div className='Connector_inner'>
						<img src={item.img} />
						<p>{item.name}</p>
					</div>
					{userData &&
					isAuthenticated &&
					userData?.link_State &&
					item.connector === item.provider ? (
						<button
							style={{ color: 'white' }}
							onClick={() => {
								setIsOpen(true);
							}}
							onMouseOver={() => {
								setIsHover(true);
							}}
							onMouseLeave={() => {
								setIsHover(false);
							}}
						>
							{isHover
								? `${
										textData?.modal.Disconnect ??
										'Disconnect'
								  }`
								: `${textData?.modal.connected ?? 'Connected'}`}
						</button>
					) : (
						<button
							disabled={
								userData &&
								userData?.link_State &&
								isAuthenticated &&
								item.connector !== item.provider
									? true
									: false ?? false
							}
							style={
								userData &&
								userData?.link_State &&
								isAuthenticated &&
								item.connector !== item.provider
									? { opacity: '0.5' }
									: { opacity: '1' } ?? { opacity: '1' }
							}
							onClick={() => {
								connet_walletConnect();
							}}
						>
							{textData?.modal.connect ?? 'Connect'}
						</button>
					)}
				</div>
			);
		});
	};

	return (
		<CenterModal
			isOpen={walletConnectmodal}
			onDismiss={() => {
				setWalletConnectModal(false);
			}}
			contentProps={{ style: staticModalStyles }}
		>
			<div className='WalletConnectModal_Container'>
				{isOpen ? (
					<div className='InnerModal'>
						<div className='InnderModal_innercontainer'>
							<div className='InnerModal_header'>
								<img
									onClick={() => {
										setIsOpen(false);
									}}
									src={closebtn}
									style={
										window.innerWidth < 1000
											? { width: '24px' }
											: { width: '40px' } && {
													cursor: 'pointer',
											  }
									}
								/>
							</div>
							<div className='InnerModal_content'>
								<p>{textData.modal['clear_wallet_modal']}</p>
								<div className='InnerModal_content_btnBox'>
									<button
										onClick={() => {
											logout();
										}}
									>
										{textData.modal['clear_wallet_btn']}
									</button>
									<button
										onClick={() => {
											setIsOpen(false);
										}}
									>
										{textData.modal['cancel']}
									</button>
								</div>
							</div>
						</div>
					</div>
				) : null}
				{/* </CenterModal> */}
				<div className='WalletConnectModal_header'>
					<p>Connect Wallet</p>
					<img
						onClick={() => {
							setWalletConnectModal(false);
						}}
						src={closebtn}
						style={
							window.innerWidth < 1000
								? { width: '24px' }
								: { width: '40px' } && { cursor: 'pointer' }
						}
					/>
				</div>
				<div
					className='WalletConnectModal_Address'
					style={
						userData && userAddress.length > 10
							? { display: 'flex' }
							: { display: 'block' } ?? { display: 'flex' }
					}
				>
					<div style={{ width: '100%' }}>
						<span ref={AddressRef}>
							{userData &&
							userAddress.length > 10 &&
							window.innerWidth < 1000
								? userData.wallet_address.slice(0, 20) + '...'
								: userData &&
								  userAddress.length > 10 &&
								  window.innerWidth > 1000
								? userData.wallet_address
								: 'Not Connected' ?? 'Not Connected'}
						</span>
						<p>
							{!isAuthenticated
								? `${textData.header['Please proceed with the wallet signature']}`
								: null ?? null}
						</p>
					</div>
					{window.innerWidth > 530 ? (
						// <div className="copybtnBox">
						<img
							alt='copy'
							style={
								userAddress.length > 10
									? { display: 'block' }
									: { display: 'none' } ?? { display: 'none' }
							}
							src={copyBtn}
							onClick={() => {
								_copyToClipBoard(userAddress);
							}}
						/>
					) : (
						// </div>
						<div
							className='copybtnBox'
							onClick={() => {
								_copyToClipBoard(userAddress);
							}}
						>
							<img
								alt='copy'
								style={
									userAddress.length > 10
										? { display: 'block' }
										: { display: 'none' } ?? {
												display: 'none',
										  }
								}
								src={copyBtn}
							/>
							<p>Copy Address</p>
						</div>
					)}
				</div>
				{_WalletConnector()}
				<p
					className='one_wallet_per'
					style={{ marginTop: '10px', textAlign: 'center' }}
				>
					You can connect one wallet per account
				</p>
			</div>
		</CenterModal>
	);
};

export default WalletConnectModal;

const staticModalStyles = {
	height: '555px',
	padding: '20px',
	borderRadius: '1rem',
	background: '#22262B',
	border: '1px solid #A1A1A1',
	animation: 'none',
	width: window.innerWidth > 1000 ? '70%' : '90%',
	maxWidth: window.innerWidth > 1000 ? '90rem' : '70rem',
};

const InnerModalStyles = {
	height: '333px',
	padding: '20px',
	borderRadius: '1rem',
	background: '#22262B',
	border: '1px solid #A1A1A1',
	animation: 'none',
	width: window.innerWidth < 1000 ? '70%' : '50%',
	maxWidth: window.innerWidth < 1000 ? '90rem' : '70rem',
};
